<script setup lang="ts">
import { useSnackBarStore } from '@/stores/snack-bar.ts'
import { storeToRefs } from 'pinia'

const snackBarStore = useSnackBarStore()
const { snackBar, content, color, location, timeout } = storeToRefs(snackBarStore)
</script>

<template>
  <v-snackbar v-model="snackBar" :timeout="timeout" :color="color" :location="location">
    <span v-html="content"></span>
  </v-snackbar>
</template>
